import React, { useEffect, useState } from 'react';
import {
  getSnackBar,
  fieldValidation,
  useNotification,
  getDialogHeading,
  dropDownValidation,
  renderSaveCancelButtons,
} from 'utils/commonUtils';
import * as yup from 'yup';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import { PaperProps } from 'constants';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector, useDispatch } from 'react-redux';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { displaySnackbar } from 'components/snackbar/store/SnackbarSlice';
import { putStudentTrackerCell } from 'layouts/studentTracking/services/studentTrackerApi';

const validationSchema = yup.object().shape({
  status: dropDownValidation,
  statusNote: fieldValidation(4000, false),
});

const StudentTrackerEditDialog = ({
  open,
  setOpen,
  columnData,
  fetchTrackerStudentData,
}) => {
  const { handleErrorResponse, NotificationPopup } = useNotification();

  const dispatch = useDispatch();

  const selectedSsaStudentDetails = useSelector(
    (state) => state?.ssaStudentDetail?.selectedSsaStudentDetails || {},
  );

  const [loading, setLoading] = useState(false);

  const defaultValue = {
    status: columnData?.status || '',
    statusNote: columnData?.note || '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(validationSchema),
  });

  const { handleSubmit, control, reset, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    if (columnData) {
      reset({
        status: columnData?.status || '',
        statusNote: columnData?.note || '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnData]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    const { status, statusNote } = data;

    const payload = {
      status,
      note: statusNote,
      column: columnData?.column,
      previousVersion: columnData?.version ?? null,
      checked: status === 'Completed' ? true : false,
      studentId: selectedSsaStudentDetails?.studentId,
    };
    const snackBar = getSnackBar(
      `successfully ${columnData?.column} data is saved`,
    );
    try {
      setLoading(true);
      await putStudentTrackerCell(payload, columnData?.trackerId);
      dispatch(displaySnackbar(snackBar));
      fetchTrackerStudentData();
      handleClose();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const statusOptions =
    columnData?.statusOptions?.map((item) => ({
      id: item,
      value: item,
    })) || [];

  return (
    <>
      <Dialog open={open} PaperProps={PaperProps}>
        {getDialogHeading('Status', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputDropdown
              name="status"
              label="Status"
              control={control}
              options={statusOptions}
              errors={!!errors.status}
              helperText={errors?.status?.message}
            />
            <FormInputText
              multiline
              minRows={3}
              type="text"
              label="Note"
              maxRows={10}
              name="statusNote"
              control={control}
              errors={!!errors.statusNote}
              helperText={errors?.statusNote?.message}
            />
            <MDBox mt={1}></MDBox>
            {renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loading,
              false,
            )}
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default StudentTrackerEditDialog;
